import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  (muiTheme) => ({
    bgCard: {
      [muiTheme.breakpoints.up('md')]: {
        height: '100%',
      },
    },
    button: {
      width: '100%',

      [muiTheme.breakpoints.up('md')]: {
        height: '100%',
      },
    },
    cardMedia: {
      width: '100%',

      [muiTheme.breakpoints.up('md')]: {
        height: '100%',
      },
    },
  }),
  { name: 'GenFeaturedContentCtaCard' },
);

export default useStyles;
